export default __webpack_public_path__ + "static/media/LucidaSansRegular.34f5b1c4.ttf";